import { Instagram, Linkedin, Mail, MapPin, Phone } from "lucide-react";

const scrollTo = (hash) => (e) => {
  e.preventDefault();
  if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -72 });
  else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-ink text-ivory" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <p className="font-serif text-3xl sm:text-4xl">Results that move you.</p>
            <p className="mt-4 max-w-sm text-sm font-light leading-relaxed text-ivory/60">
              Will French — REALTOR® | Team Partner at CHK Real Estate, serving South Mississauga,
              South Oakville, South Etobicoke and Downtown Toronto.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.instagram.com/willfrenchrealestate/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="flex h-10 w-10 items-center justify-center border border-ivory/25 transition-colors hover:border-ivory hover:bg-ivory hover:text-ink"
              >
                <Instagram size={15} />
              </a>
              <a
                href="https://www.linkedin.com/in/will-french-b2695343/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
                className="flex h-10 w-10 items-center justify-center border border-ivory/25 transition-colors hover:border-ivory hover:bg-ivory hover:text-ink"
              >
                <Linkedin size={15} />
              </a>
            </div>
          </div>

          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-ivory">Contact</p>
            <ul className="mt-5 space-y-4 text-sm font-light text-ivory/80">
              <li className="flex items-start gap-3">
                <Phone size={14} className="mt-0.5 shrink-0" />
                <a href="tel:+16475359455" data-testid="footer-phone" className="transition-colors hover:text-ivory">
                  (647) 535-9455
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={14} className="mt-0.5 shrink-0" />
                <a
                  href="mailto:will@corriehardingteam.com"
                  data-testid="footer-email"
                  className="transition-colors hover:text-ivory"
                >
                  will@corriehardingteam.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="mt-0.5 shrink-0" />
                103 Lakeshore Road East,
                <br />
                Mississauga, ON L5G 1E2
              </li>
            </ul>
          </div>

          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-ivory">Explore</p>
            <ul className="mt-5 space-y-4 text-sm font-light text-ivory/80">
              <li>
                <a href="#book" onClick={scrollTo("#book")} data-testid="footer-book-link" className="transition-colors hover:text-ivory">
                  Book a Consultation
                </a>
              </li>
              <li>
                <a href="#about" onClick={scrollTo("#about")} data-testid="footer-about-link" className="transition-colors hover:text-ivory">
                  About Will
                </a>
              </li>
              <li>
                <a
                  href="https://www.corriehardingteam.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-main-site"
                  className="transition-colors hover:text-ivory"
                >
                  corriehardingteam.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-ivory/15 pt-6 text-[11px] font-light text-ivory/45 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Will French · CHK Real Estate · Powered by Royal LePage</p>
          <p>Established 2003 · Serving the Greater Toronto Area</p>
        </div>
      </div>
    </footer>
  );
}